var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunicationsBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 507,
    height: 499,
    viewBox: "0 0 507 499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "f5uzcc2vfa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0H507V499H0z",
    transform: "translate(0 269)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f5uzcc2vfa)",
    transform: "translate(0 -269)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-11 1846.084 2238.284) translate(0 .911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.324 154.4l-46.991-44.41a68.863 68.863 0 0 0 8.859-33.349 70.165 70.165 0 1 0-32.839 58.959l46.925 44.361a159.608 159.608 0 0 1 24.046-25.561z",
    transform: "translate(104.41 92.586)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.924 242.342l62.441-105.076a68.917 68.917 0 1 0-30.292-17.686L27.829 224.361a155.938 155.938 0 0 1 30.095 17.981z",
    transform: "translate(429.573 -.911)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.68 20.952a69.629 69.629 0 0 0-65.219 45.61L36.711 58c0 .657.1 1.282.1 1.923a159.746 159.746 0 0 1-3.5 33.02l86.717 8.563a69.59 69.59 0 1 0 68.652-80.554z",
    transform: "translate(514.163 308.445)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.653 117.213L76.258 32.468a158.8 158.8 0 0 1-34.22 7.906l19.428 84.761c-22.271 11.653-37.639 34.68-37.639 61.57a69.7 69.7 0 1 0 71.826-69.492z",
    transform: "translate(367.798 486.208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.974 25.37L127.988 61.546A69.569 69.569 0 1 0 139.4 99.563c0-1.611-.345-3.09-.477-4.668L247.249 58.62a159.141 159.141 0 0 1-11.275-33.25z",
    transform: "translate(0 376.642)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.507,
    cy: 119.507,
    r: 119.507,
    transform: "translate(272.167 248.86)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationsBg);
export default __webpack_public_path__ + "static/media/communicationsBg.8fe5df3abf27f36678e7e61b6088f74a.svg";
export { ForwardRef as ReactComponent };